import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';
import { UploadReqStepRecruitersComponent } from './upload-req-step-recruiters.component';

@NgModule({
  declarations: [UploadReqStepRecruitersComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    VoiceInputModule,
    FormalizeCommentModule
  ],
  exports: [UploadReqStepRecruitersComponent],
  entryComponents: [UploadReqStepRecruitersComponent]
})
export class UploadReqStepRecruitersModule { }
